<mat-form-field appearance="outline" class="otp-form-field">
  <input
    matInput
    type="text"
    maxlength="1"
    class="otp-input"
    [formControl]="otpControl"
    [readonly]="disabled"
    (keydown)="onKeydown($event)"
    (paste)="onPaste($event)"
    pattern="[0-9]"
    inputmode="numeric"
  />
</mat-form-field>